'use client'

import { useEffect } from 'react'

// Catches errors thrown by the root layout itself (Sidebar, Header, Providers)
// which app/error.tsx cannot see since it only wraps the page segment.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang='en'>
      <body
        style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          fontFamily: 'sans-serif',
          background: '#04060A',
          color: '#E7E7E7',
          textAlign: 'center',
          padding: '1rem',
        }}
      >
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600 }}>Something went wrong</h2>
        <p style={{ maxWidth: '28rem', color: '#848EAA', fontSize: '0.875rem' }}>
          {error.message || 'An unexpected error occurred.'}
        </p>
        <button
          onClick={reset}
          style={{
            borderRadius: '999px',
            padding: '0.5rem 1.5rem',
            background: 'linear-gradient(to right, #141A42, #535EA4)',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  )
}
